import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, RotateCcw } from "lucide-react";

export const MODALITY_LABELS = { elearning: "E-learning", videoconferenza: "Videoconferenza", aula: "Aula" };

export const filterCourses = (list, q, cat, mod) => {
  const s = q.trim().toLowerCase();
  return list.filter((c) => (cat === "all" || c.category === cat) && (mod === "all" || c.modality === mod)
    && (!s || [c.title, c.description, c.category].some((v) => (v || "").toLowerCase().includes(s))));
};

export const filterLabel = (q, cat, mod) => [q.trim() && `Ricerca: "${q.trim()}"`, cat !== "all" && `Categoria: ${cat}`,
  mod !== "all" && `Modalità: ${MODALITY_LABELS[mod] || mod}`].filter(Boolean).join(" · ");

export async function downloadCoursesPdf(url, courseIds, label) {
  const r = await api.post(url, { course_ids: courseIds, filter_label: label }, { responseType: "blob" });
  const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = href; a.download = "catalogo-corsi.pdf"; a.click();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export function CourseFilters({ q, setQ, cat, setCat, mod, setMod, categories, count }) {
  return (
    <Card className="border-slate-200"><CardContent className="p-4 flex flex-wrap items-end gap-3">
      <div className="flex-1 min-w-[220px]">
        <Label className="text-xs">Cerca</Label>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Titolo, descrizione, categoria…" className="pl-9" data-testid="courses-search-input" />
        </div>
      </div>
      <div className="min-w-[180px] flex-1 sm:flex-none">
        <Label className="text-xs">Categoria</Label>
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger data-testid="courses-category-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Tutte le categorie</SelectItem>{categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="min-w-[180px] flex-1 sm:flex-none">
        <Label className="text-xs">Modalità</Label>
        <Select value={mod} onValueChange={setMod}>
          <SelectTrigger data-testid="courses-modality-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Tutte le modalità</SelectItem>{Object.entries(MODALITY_LABELS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <Button variant="outline" onClick={() => { setQ(""); setCat("all"); setMod("all"); }} data-testid="courses-filter-reset"><RotateCcw className="w-4 h-4 mr-1" /> Azzera</Button>
      <span className="text-sm text-slate-500 pb-2" data-testid="courses-count">{count} corsi</span>
    </CardContent></Card>
  );
}
